import React, {useState} from 'react';
import { useSelector, useDispatch} from 'react-redux';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  TextField,
  Icon,
  IconButton,
  Checkbox
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { createStoreCategoryApi } from 'api';


const AddCategoryModal = ({open, setOpen, onConfirm, itemName, isMassEdit = false}) => {
  const dispatch = useDispatch();

  const { storeCategoriesTree } = useSelector((state) => state.categories);

  const [rootCategory, setRootCategory] = useState(false);
  const [rootSubCategory, setRootSubCategory] = useState(false);
  const [finalSubCategory, setFinalSubCategory] = useState(false);

  const [addNewRootSubCategory, setAddNewRootSubCategory] = useState(false);
  const [addNewSubCategory, setAddNewSubCategory] = useState(false);


  const [newCategory, setNewCategory] = useState(false);


  const createNewCategory = (event, parentCategory) => {
    const {value} = event.target;
    const urlPath = value.toLowerCase().split(' ').join('-');
    const categoryData = {
      parent_id: parentCategory.id,
      name: value,
      is_active: false,
      position: parentCategory.children_data.length + 1,
      level: parentCategory.level + 1,
      children: [],
      include_in_menu: false,
      extension_attributes: {},
      custom_attributes: [
        {
          attribute_code: 'description',
          value: `<h2>${value}</h2>`,
        },
        {
          attribute_code: 'url_key',
          value: urlPath
        },
        {
          attribute_code: 'url_path',
          value: urlPath
        },
        {
          attribute_code: 'categoryuniqueid',
          value: `CUSTOM-${Math.random().toString(36).substr(2, 9)}`
        },
      ]
    };
    setNewCategory(categoryData);
  };

  const handleConfirmCategory = async () => {
    if (finalSubCategory && rootSubCategory && rootCategory && !newCategory) {
      onConfirm(finalSubCategory);
    }

    if (!finalSubCategory && rootSubCategory && rootCategory && !newCategory) {
      onConfirm(rootSubCategory);
    }

    if (!finalSubCategory && rootCategory && newCategory) {
      const createdCategory = await createStoreCategoryApi({
        dispatch,
        category: newCategory
      });

      if (isMassEdit) {
        onConfirm(createdCategory);
      }
    }

    if (!finalSubCategory && !rootSubCategory && rootCategory && !newCategory) {
      onConfirm(rootCategory);
    }

    setOpen(false);
  };

  const handleRootSubCategory = () => {
    return (
      <>
        {!addNewRootSubCategory && rootCategory.children_data.length > 0 &&
        <>
          <Typography variant="h6" className="mt-6 mb-2">Sub Category 1st level:</Typography>
          <Autocomplete
            disableClearable
            options={rootCategory.children_data}
            getOptionLabel={(option) => option.name}
            defaultValue={''}
            value={rootSubCategory ? rootSubCategory : ''}
            onChange={(event, value) => {
              setRootSubCategory(value);
              setAddNewSubCategory(false);
              setFinalSubCategory(false);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Categories"
                placeholder="Add category..."
                size="small"
              />
            )}
          />
        </>
        }
        {rootSubCategory &&
        <>
          <Typography variant="body1" className="mb-4">
            <Checkbox
              color="primary"
              checked={addNewSubCategory}
              onChange={(event) => {
                const {checked} = event.target;
                setAddNewSubCategory(checked);
                setNewCategory(false);
              }}
            />
            Do you want to add new subcategory for <strong>{rootSubCategory.name}</strong>?
          </Typography>
        </>
        }
        {addNewSubCategory && !addNewRootSubCategory && rootSubCategory &&
        <>
          <Typography variant="body1" className="my-4">
            Set new subcategory for <strong>{rootSubCategory.name}</strong>
          </Typography>
          <div className="flex items-center">
            <TextField
              fullWidth
              variant="outlined"
              label="New Category name"
              onChange={(event) => createNewCategory(event, rootSubCategory)}
            />
            <IconButton onClick={() => setAddNewSubCategory(false)}>
              <Icon>close</Icon>
            </IconButton>
          </div>
        </>
        }
      </>
    );
  };

  const handleFinalSubCategory = () => {
    return (
      <>
        <Typography variant="h6" className="mt-4 mb-2">Sub Category 2nd level:</Typography>
        <Autocomplete
          disableClearable
          options={rootSubCategory.children_data}
          getOptionLabel={(option) => option.name}
          defaultValue={''}
          value={finalSubCategory ? finalSubCategory : ''}
          onChange={(event, value) => setFinalSubCategory(value)}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Categories"
              placeholder="Add category..."
              size="small"
            />
          )}
        />
      </>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth={'md'}
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h4" className="mt-4">Choose Category for &lsquo;{itemName}&rsquo;</Typography>
      </DialogTitle>
      <DialogContent  className="m-4">
        <Typography variant="h6" className="mb-2">Root Category:</Typography>
        {!!storeCategoriesTree.length &&
          <Autocomplete
            disableClearable
            options={storeCategoriesTree[0].children_data}
            getOptionLabel={(option) => option.name}
            defaultValue={rootCategory ? rootCategory.name : ''}
            onChange={(event, value) => {
              setRootCategory(value);
              setRootSubCategory(false);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Categories"
                placeholder="Add category..."
                size="small"
              />
            )}
          />
        }
        {rootCategory &&
        <>
          <Typography variant="body1" className="mb-4">
            <Checkbox
              color="primary"
              checked={addNewRootSubCategory}
              onChange={(event) => {
                const {checked} = event.target;
                setAddNewRootSubCategory(checked);
                setRootSubCategory(false);
                setNewCategory(false);
              }}
            />
            Add new subcategory for <strong>{rootCategory.name}</strong>
          </Typography>
          {addNewRootSubCategory &&
            <>
              <Typography variant="body1" className="my-4">
                Set new subcategory for <strong>{rootCategory.name}</strong>
              </Typography>
              <div className="flex items-center">
                <TextField
                  fullWidth
                  variant="outlined"
                  label="New Category name"
                  onChange={(event) => createNewCategory(event, rootCategory)}
                />
                <IconButton onClick={() => setAddNewRootSubCategory(false)}>
                  <Icon>close</Icon>
                </IconButton>
              </div>
            </>
          }
        </>
        }

        {rootCategory && handleRootSubCategory()}

        {rootSubCategory && !addNewSubCategory && rootSubCategory.children_data.length > 0 && handleFinalSubCategory()}
      </DialogContent>
      <DialogActions className="m-4">
        <Button
          variant="contained"
          onClick={() => setOpen(false)}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirmCategory}
          color="primary"
          disabled={!rootCategory}
        >
          Confirm Your Choice
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCategoryModal;
